"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_property_decorator_1 = require("vue-property-decorator");
var Spinner_vue_1 = __importDefault(require("@/components/spinner/Spinner.vue"));
var RegisterAccount_vue_1 = __importDefault(require("@/views/register-account/RegisterAccount.vue"));
var ViewWrapper_vue_1 = __importDefault(require("@/components/view-wrapper/ViewWrapper.vue"));
var BaseView_1 = require("../BaseView");
var PasswordResetAuthorized = /** @class */ (function (_super) {
    __extends(PasswordResetAuthorized, _super);
    function PasswordResetAuthorized() {
        var _this = _super.call(this) || this;
        _this.validationState = {
            password: { state: null, message: null }
        };
        _this.password = '';
        _this.passwordConfirmation = '';
        _this.formHasErrors = false;
        return _this;
    }
    PasswordResetAuthorized.prototype.mounted = function () {
        var _this = this;
        this.$verifyForgotPasswordAuthorizationService.request(this.$route.params.authorizationId, this.$route.params.authorizationCode).then(function (response) {
            _this.loader = false;
            _this.userId = response.id;
        }, function (error) {
            if (error.response.status === 400) {
                _this.$router.push({ name: 'forgotPasswordVerifyCode', params: { authorizationId: _this.$route.params.authorizationId, error: 'invalidCode' } });
            }
            else {
                _this.$router.push({ name: 'error', params: { code: error.response.status } });
            }
        });
    };
    PasswordResetAuthorized.prototype.submit = function () {
        var _this = this;
        this.resetValidationState();
        this.formHasErrors = !this.validation();
        if (this.formHasErrors) {
            return;
        }
        this.loader = true;
        this.$changePasswordAuthorizedService.request(this.password, this.userId, this.$route.params.authorizationId).then(function () { return _this.$router.push({ name: 'checkPartnership' }); }, function (error) { return _this.$router.push({ name: 'error', params: { code: error.response.status } }); });
    };
    PasswordResetAuthorized.prototype.validation = function () {
        if (!this.password) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            this.validationState.password.message = this.$t('validation.valueMandatory');
            return this.validationState.password.state = false;
        }
        if (this.password.toString().length < RegisterAccount_vue_1.default.PASSWORD_MINIMUM_CHARACTERS) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            this.validationState.password.message = this.$t('validation.passwordLength.replace', { number: RegisterAccount_vue_1.default.PASSWORD_MINIMUM_CHARACTERS });
            return this.validationState.password.state = false;
        }
        if (this.password !== this.passwordConfirmation) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            this.validationState.password.message = this.$t('validation.passwordMatch');
            return this.validationState.password.state = false;
        }
        return true;
    };
    PasswordResetAuthorized.prototype.resetValidationState = function () {
        this.validationState.password = { state: null, message: null };
    };
    PasswordResetAuthorized = __decorate([
        vue_property_decorator_1.Component({
            name: 'PasswordResetAuthorized',
            components: {
                Spinner: Spinner_vue_1.default,
                ViewWrapper: ViewWrapper_vue_1.default
            },
            metaInfo: function () {
                var title = this.$t("title." + this.$route.name);
                var metaInfo = {
                    title: this.$t('title.default'),
                    titleTemplate: '%s | ' + title,
                    meta: [
                        { name: 'og:title', content: title },
                        { name: 'og:url', content: window.location.href }
                    ],
                    link: [
                        { rel: 'canonical', href: window.location.href }
                    ]
                };
                return metaInfo;
            },
        })
    ], PasswordResetAuthorized);
    return PasswordResetAuthorized;
}(BaseView_1.BaseView));
exports.default = PasswordResetAuthorized;
